// @core/api/endpoints/fiscalization/update_fiscal_point.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateFiscalPointRequest,
  UpdateFiscalPointResponse,
} from '../../../types/fiscalization';

const BASE_PATH = '/fiscalization';

/**
 * Update fiscal point
 * Updates fiscal point details such as name, taxation system, or fiscal drive information.
 */
export async function UpdateFiscalPoint(
  id: string,
  data: UpdateFiscalPointRequest,
  options?: RequestOptions
): Promise<UpdateFiscalPointResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/fiscal-points/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.patch<UpdateFiscalPointResponse>(requestPath, data, requestOptions);
}
